import { Flex as BaseFlex, omitProps, FlexProps } from '@qga/roo-ui/components';
import styled, { StyledComponent } from '@emotion/styled';
import { css } from '@emotion/core';
import { FC } from 'react';

interface RowProps extends FlexProps {
  spacing: string | number;
}

const spacing = (props: RowProps & { theme: any }) => {
  const { spacing, theme } = props;
  const spacingPx = typeof spacing === 'number' ? theme.space[spacing] : spacing;
  return spacing
    ? css`
        margin-left: -${spacingPx};
        margin-right: -${spacingPx};
        & > * {
          padding-left: ${spacingPx};
          padding-right: ${spacingPx};
        }
      `
    : false;
};

const Flex = styled(BaseFlex, omitProps(['spacing']))`
  ${spacing}
` as StyledComponent<RowProps, RowProps, any>;

const Row: FC = (props) => <Flex flex="1 1 auto" flexWrap="wrap" spacing="10px" {...props} />;

Row.displayName = 'Row';

export default Row;
